import { Box, Button } from '@mui/material'
import { useReviewModal } from './hooks/useReviewModal'
import { ReviewModal } from './ReviewModal'

export const Review = () => {
  const { open, openModal, closeModal } = useReviewModal()
  return (
    <Box sx={{ alignSelf: 'flex-end' }}>
      <Button
        variant="text"
        color="info"
        size="small"
        onClick={() => openModal()}
      >
        MEDIA MANAGEMENT REVIEW
      </Button>
      <ReviewModal open={open} onClose={closeModal} />
    </Box>
  )
}
